module.exports = __webpack_public_path__ + "a3918f203df35bb7db90c3706d2fb8b1.fbx";